import React, { Component, Suspense } from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

import windowSize from 'react-window-size';
import './../../assets/scss/style.scss';

import * as loginActions from "../../API/Login/loginActions";
import * as AppUtils from "../../Utils/AppUtils";
import appConstants from "../../appConstants";

class LicenseAgreement extends Component {

	constructor(props)
	{
		super(props);
		this.state = 
		{
			user : ((this.props.loginData && !AppUtils.isObjEmpty(this.props.loginData)) ? this.props.loginData : {}) //AppUtils.getSessionStorageData(appConstants.USER_SESSION_KEY)
		}
	}

	componentWillReceiveProps(nextProps)
	{
		if((!nextProps.updateUserLicenseAgreementStatusLoading && nextProps.loginData != this.props.loginData) || (nextProps.loginData != this.props.loginData))
		{
			this.setState
			(
				{
					user: nextProps.loginData
				}
			)
			AppUtils.saveSessionStorageData(appConstants.USER_SESSION_KEY, nextProps.loginData);
		}
	}

	onClickAgreeBtn()
	{
		if(this.state.user && !AppUtils.isObjEmpty(this.state.user))
		{
			this.props.loginActions.updateUserLicenseAgreementStatus(this.state.user.userId)
		}
	}

	onCloseLicenseAgreement()
	{
		var loginData = {};
		this.props.loginActions.logout(false);
		this.props.loginActions.loginDataAction(loginData);
		AppUtils.removeSessionStorageData(appConstants.USER_SESSION_KEY);
	}

	render() 
	{
		return (
			<div>
				<Redirect to={{ pathname: appConstants.LICENSE_AGREEMENT_SCREEN }}></Redirect>
				<div className="agreement-auth-wrapper">
					<div className="agreement-auth-content">
						<div className="card">
							<div className="card-body">
								<div className="d-flex justify-content-between">
									<div></div>
									<div><h3 className="mb-4  text-center">Terms of Service agreement</h3></div>
									<div onClick={() => { this.onCloseLicenseAgreement() }}><i className="feather icon-x" /></div>
								</div>
								<div className="input-group mb-3 agreement-content" style={{ height: window.innerHeight * 0.63 }}>
									<PerfectScrollbar>
										<p>Last Updated: July 27, 2021</p>
										<p>THANK YOU FOR USING OUR PRODUCTS AND SERVICES (“SERVICES”). THE SERVICES ARE PROVIDED BY VIE TECHNOLOGIES, INC (“VIE”), A NEVADA CORPORATION LOCATED AT 9474 KEARNEY VILLA, SUITE 105, SAN DIEGO, 92126, UNITED STATES.</p>
										<p>BY PRESSING THE “I ACCEPT” BUTTON DURING INSTALLATION, LOGIN OR USE, YOU ARE AGREEING TO THESE TERMS. PLEASE READ THEM CAREFULLY</p>
										<h4>End-User License Agreement (EULA)</h4>
										<p>This End-User License Agreement ("EULA") is a legal agreement between you and VIE Technologies, Inc (“VIE”)</p>
										<p>This EULA agreement governs your acquisition and use of our VIE software ("Software") directly from VIE or indirectly through a VIE authorized reseller or distributor (a "Reseller").</p>
										<p>Please read this EULA agreement carefully before completing the installation process and using the VIE software. It provides a license to use the VIE software and contains warranty information and liability disclaimers.</p>
										<p>If you register or in any way arrange for a free trial of the VIE software, this EULA agreement will also govern that trial. By clicking "accept" or installing and/or using the VIE software, you are confirming your acceptance of the Software and agreeing to become bound by the terms of this EULA agreement.</p>
										<p>If you are entering into this EULA agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity and its affiliates to these terms and conditions. If you do not have such authority or if you do not agree with the terms and conditions of this EULA agreement, do not install or use the Software, and you must not accept this EULA agreement.</p>
										<p>This EULA agreement shall apply only to the Software supplied by VIE herewith regardless of whether other software is referred to or described herein. The terms also apply to any VIE updates, supplements, Internet-based services, and support services for the Software, unless other terms accompany those items on delivery. If so, those terms apply.</p>
										<h4>1.	License Grant</h4>
										<p>VIE hereby grants you a personal, non-transferable, non-exclusive license to use the VIE software on your devices in accordance with the terms of this EULA agreement.</p>
										<p>You are permitted to load the VIE software on a device (for example a PC, laptop, mobile or tablet) under your control. You are responsible for ensuring your device meets the minimum requirements of the VIE software.</p>
										<p>You are not permitted to:</p>
										<ul>
											<li>Edit, alter, modify, adapt, translate or otherwise change the whole or any part of the Software nor permit the whole or any part of the Software to be combined with or become incorporated in any other software, nor decompile, disassemble or reverse engineer the Software or attempt to do any such things</li>
											<li>Reproduce, copy, distribute, resell or otherwise use the Software for any commercial purpose</li>
											<li>Allow any third party to use the Software on behalf of or for the benefit of any third party</li>
											<li>Use the Software in any way which breaches any applicable local, national or international law</li>
											<li>Use the Software for any purpose that VIE considers is a breach of this EULA agreement</li>
										</ul>
										<h4>2.	Intellectual Property and Ownership</h4>
										<p>VIE shall at all times retain ownership of the Software as originally downloaded by you and all subsequent downloads of the Software by you. The Software (and the copyright, and other intellectual property rights of whatever nature in the Software, including any modifications made thereto) are and shall remain the property of VIE.</p>
										<p>VIE reserves the right to grant licenses to use the Software to third parties.</p>
										<h4>3.	Termination</h4>
										<p>This EULA agreement is effective from the date you first use the Software and shall continue until terminated. You may terminate it at any time upon written notice to VIE.</p>
										<p>It will also terminate immediately if you fail to comply with any term of this EULA agreement. Upon such termination, the licenses granted by this EULA agreement will immediately terminate and you agree to stop all access and use of the Software. The provisions that by their nature continue and survive will survive any termination of this EULA agreement.</p>
										<h4>4.	Warranty</h4>
										<p>VIE MAKES NO WARRANTIES, EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, WITH RESPECT TO THE LICENSED MATERIALS, OR ANY OTHER ACCOMPANYING MATERIAL PROVIDED HEREUNDER. VIE SPECIFICALLY DISCLAIMS ALL OTHER WARRANTIES, EXPRESS AND IMPLIED, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT, THOSE ARISING FROM A COURSE OF DEALING OR USAGE OR TRADE, AND OF UNINTERRUPTED OR ERROR-FREE SERVICE, AND ALL SUCH WARRANTIES ARE HEREBY EXCLUDED TO THE FULLEST EXTENT PERMITTED BY LAW. EXCEPT AS EXPRESSLY PROVIDED HEREIN, THE SOFTWARE IS PROVIDED ON AN AS IS, AS AVAILABLE BASIS.</p>
										<h4>5.	Limitation on Damages</h4>
										<p>EXCLUSION OF INCIDENTAL AND CONSEQUENTIAL DAMAGES. EXCEPT FOR BREACH OF SECTION 1 OR SECTION 2 OF THIS AGREEMENT, NEITHER PARTY WILL BE LIABLE TO THE OTHER PARTY FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR EXEMPLARY DAMAGES ARISING OUT OF OR RELATED TO THIS AGREEMENT, EVEN IF THE OTHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND REGARDLESS OF WHETHER SUCH LIABILITY SOUNDS IN CONTRACT, NEGLIGENCE, TORT, STRICT LIABILITY, WARRANTY, OR OTHERWISE.</p>
										<p>MAXIMUM AGGREGATE LIABILITY. EXCEPT FOR BREACH OF SECTION 1 OR SECTION 2 OF THIS AGREEMENT, THE MAXIMUM LIABILITY OF EITHER PARTY FOR ANY CLAIMS ARISING IN CONNECTION WITH THIS AGREEMENT WILL NOT EXCEED THE AGGREGATE AMOUNT OF PAYMENTS MADE UNDER THIS AGREEMENT IN THE ONE-MONTH PERIOD PRIOR TO THE EVENT GIVING RISE TO LIABILITY. USER ACKNOWLEDGES THAT THE AMOUNTS PAYABLE HEREUNDER ARE BASED IN PART ON THESE LIMITATIONS. THE PARTIES AGREE THAT THESE LIMITATIONS SHALL APPLY NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.</p>
										<h4>6.	Governing Law</h4>
										<p>This EULA agreement, and any dispute arising out of or in connection with this EULA agreement, shall be governed by and construed in accordance with the laws of the State of Nevada, without giving effect to its principles regarding conflicts of law.</p>
									</PerfectScrollbar>
								</div>
								<button className="btn btn-primary shadow-2 mb-4" onClick={() => this.onClickAgreeBtn()}>I Agree</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => 
{
	return {
		updateUserLicenseAgreementStatusLoading: state.updateUserLicenseAgreementStatusLoadingReducer,
		loginData: state.loginDataReducer
	}
};

const mapDispatchToProps = dispatch => 
{
	return {
		loginActions: bindActionCreators(loginActions, dispatch)
	}
};

export default connect(mapStateToProps, mapDispatchToProps) (windowSize(LicenseAgreement));